import React from 'react';
import KlaviyoLogo from '../icons/KlaviyoLogo';
import GoogleAdsLogo from '../icons/GoogleAdsLogo';
import ShopifyLogo from '../icons/ShopifyLogo';
import MetaLogo from '../icons/MetaLogo';
import InstagramLogo from '../icons/InstagramLogo';

function PerformanceMetric({ name, score, connected, onConnect }) {
  const getLogos = (name) => {
    switch (name) {
      case 'Emails':
        return [<KlaviyoLogo key="klaviyo" className="h-5 w-5" />];
      case 'Ads':
        return (
          <div className="flex space-x-2">
            <GoogleAdsLogo key="google-ads" className="h-5 w-5" />
            <MetaLogo key="meta" className="h-5 w-5" />
          </div>
        );
      case 'Website':
        return [<ShopifyLogo key="shopify" className="h-5 w-5" />];
      case 'Social':
        return [<InstagramLogo key="instagram" className="h-5 w-5" />];
      default:
        return null;
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg">
      <div className="flex flex-col items-center">
        <div className="flex items-center space-x-4 mb-4">
          <h3 className="text-sm font-medium text-gray-900">{name}</h3>
          <div className="flex space-x-2">
            {getLogos(name)}
          </div>
        </div>
        <div className="relative mb-4">
          {/* Square border container */}
          <div className="w-24 h-24 border-4 border-gray-100 rounded-lg flex items-center justify-center">
            {/* Circular progress indicator */}
            <div className="relative w-16 h-16">
              {/* Progress circle background */}
              <div className="absolute inset-0 rounded-full border-4 border-gray-100" />
              
              {/* Progress circle fill */}
              <svg className="absolute inset-0 w-full h-full -rotate-90">
                <circle
                  cx="32"
                  cy="32"
                  r="28"
                  strokeWidth="8"
                  stroke="#0049ac"
                  fill="none"
                  strokeDasharray={`${score * 1.76} 176`}
                  className="transition-all duration-500"
                />
              </svg>
              
              {/* Center percentage text */}
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-lg font-semibold text-gray-900">{score}%</span>
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={onConnect}
          className="mt-2 px-4 py-2 bg-[#0049ac] text-white rounded-md text-sm font-medium hover:bg-[#0049ac]/90 transition-colors w-full"
        >
          View Details
        </button>
      </div>
    </div>
  );
}

export default PerformanceMetric;